import { defineCollection } from "@rebasepro/cms-types";
import { personName, playerOf } from "../people";

// Two people who are friends (songbuzz_friend), the smaller account first, with how many games they've played together.
// backend/src/friends.ts creates and writes it.
const friendshipsCollection = defineCollection({
    name: "Friendships",
    singularName: "Friendship",
    slug: "friendships",
    table: "songbuzz_friend",
    description: "Pairs of people who are friends, and how many games they've played together.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operation: "delete", roles: ["admin"] },
    ],
    properties: {
        a: { name: "Person (id)", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        b: { name: "Friend (id)", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        person: playerOf("Person", "a", "person"),
        friend: playerOf("Friend", "b", "friend"),
        since: { name: "Since", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
        games: { name: "Games together", type: "number", columnType: "integer", defaultValue: 1, validation: { required: true }, admin: { readOnly: true } },
        lastGame: { name: "Last game together", description: "Its room code", type: "string", admin: { readOnly: true } },
    },
    admin: {
        icon: "Handshake",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["since", "desc"],
        display: {
            title: async ({ entity, context }) => `${await personName(context, entity.values.a)} & ${await personName(context, entity.values.b)}`,
            subtitle: ({ entity }) => `${entity.values.games ?? 0} games together`,
            date: "since",
        },
        listProperties: ["games", "lastGame", "since"],
        form: {
            sections: [
                { key: "friends", properties: ["person", "friend", "games", "lastGame", "since"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["a", "b"] },
            ],
        },
    },
});

export default friendshipsCollection;
